module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABSElEQVRYR+2XoU4DQRCG/9kLCQ4FAtEcXBXgMPQC4Q0QPEEdwaFJaWkvRaLQUIECgYIEBSS08ACEoMqBBoGmO0OuaRNCyO2SboLZMStmdufLlxGzhJyIGsuLrPQsgSZZYyqv1jaX1jq732vpt4uFvZW5QOstAGUAbwDeAcnOkUKYbowAWXOl9QkBD7qntl/rt92Rug4uzySlKyuAMCntE6nic6W95qLx8I0/AMTnEJym1U7rXwD6pJB6unN/7QG8AW/AG/AGvAFvwBvwBopJHLmyoIFjYVwat+LhShZo9cgBXgCMGyA+B/kxQ11PGE1rAL8TEmgeoAOD1o8f+Ym8ehE6S6vt9dyvWTYDRHjqVu42o2a84GoImXEojAvjDISNuEyEIyK0WPeH0EmQklWrr1nWLawthQiCDRAKBJ52QgDAGsBVQ5t3vgBI9KEwEtSflwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left/journal1.png
// module id = VsFy
// module chunks = 3